export namespace UnsubscribeRule {
  export class Enum {
    static readonly DEFAULT = new Enum('DEFAULT')

    static readonly NO_BLOCK = new Enum('NO_BLOCK')

    public constructor(public readonly name: string) {}

    is(rule: UnsubscribeRule.Enum | null): boolean {
      return this.name === rule?.name
    }
  }

  export const getByName = (name: string): Enum => {
    return Object.values(UnsubscribeRule.Enum).find(rule => rule.name === name)
  }
}
